/**
 * @Description Application Router - deals with public and protected routing
 * @FileName fasatRouter.js
 * @Author Arnab Sutar - sutaarn
 * @CreatedOn 25 January, 2021 07:56:35
 * @IssueID - 311
 */

import React, { Suspense } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { Route, Routes } from 'react-router-dom';
import { FasatProtectedRoute, FasatPublicRoute } from './app/common/components';
import appRouting from './config/appRouting';
import FasatHome from './fasatHome';

/**
 * Component which should be shown during the lazy component being loaded
 */
const FallbackComponent = () => 'Loading...';

/**
 * Fasat application route which dynamically create all the configured
 * routes. please refer /config/routeConfig.js file for route configuration
 */
function FasatRouter({ isBatchProcessing, menuItems }) {
  const publicRoutes = appRouting.filter((route) => route.public);
  const protectedRoute = appRouting.filter((route) => !route.public);
  const userClaim = useSelector((state) => state.ApplicationStateRBAC.rbacData);
  const { isExternalUser } = useSelector((state) => state.ApplicationStateRBAC);

  return (
    <Suspense fallback={<FallbackComponent />}>
      <Routes>
        <Route path="/" exact element={<FasatHome isExternalUser={isExternalUser} menuItems={menuItems} />} />
        <Route path="/signin-oidc" exact element={<FasatHome />} />
        {/* this component can be wrapped as PublicRouteComponent. */}
        {publicRoutes.map((route) => (
          <Route
            key={route.id}
            path={route.path}
            exact={route.exact}
            element={<FasatPublicRoute component={route.component} routeConfig={route} />}
          />
        ))}
        {userClaim && protectedRoute.map((route) => (
          <Route
            key={route.id}
            path={route.path}
            exact={route.exact}
            element={(
              <FasatProtectedRoute
                component={route.component}
                routeConfig={route}
                aclKey={route.aclKey[0]}
                userClaim={userClaim}
              />
            )}
          />
        ))}
        <Route path="*" element={isBatchProcessing ? <FasatHome /> : <div>404 Not found</div>} />
      </Routes>
    </Suspense>
  );
}

FasatRouter.propTypes = {
  isBatchProcessing: PropTypes.bool,
  menuItems: PropTypes.arrayOf(PropTypes.shape({})),
};

FasatRouter.defaultProps = {
  isBatchProcessing: false,
  menuItems: [],
};

export default FasatRouter;
